import axios from 'axios';
import extenso from 'extenso';
import React from 'react';
import InputMask from 'react-input-mask';
import 'react-select/dist/react-select.css';
import { toast } from 'react-toastify';
import {
  Button,
  InputGroup,
  InputGroupAddon,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import {
  REQUEST_URL,
  URL_CONTRATO_API,
  URL_NEW_MAPA_API,
} from '../config/urls';
import TelegramLog from '../services/telegram';

const MES_EXTENSO = {
  janeiro: '01',
  fevereiro: '02',
  março: '03',
  abril: '04',
  maio: '05',
  junho: '06',
  julho: '07',
  agosto: '08',
  setembro: '09',
  outubro: '10',
  novembro: '11',
  dezembro: '12',
};
export default class Contrato extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orcamento: { observacao: 'aoihdbfoahsbdfoahsbdfo' },
      estadosJson: [
        { nome: 'Acre', sigla: 'AC' },
        { nome: 'Alagoas', sigla: 'AL' },
        { nome: 'Amapá', sigla: 'AP' },
        { nome: 'Amazonas', sigla: 'AM' },
        { nome: 'Bahia', sigla: 'BA' },
        { nome: 'Ceará', sigla: 'CE' },
        { nome: 'Distrito Federal', sigla: 'DF' },
        { nome: 'Espírito Santo', sigla: 'ES' },
        { nome: 'Goiás', sigla: 'GO' },
        { nome: 'Maranhão', sigla: 'MA' },
        { nome: 'Mato Grosso', sigla: 'MT' },
        { nome: 'Mato Grosso do Sul', sigla: 'MS' },
        { nome: 'Minas Gerais', sigla: 'MG' },
        { nome: 'Pará', sigla: 'PA' },
        { nome: 'Paraíba', sigla: 'PB' },
        { nome: 'Paraná', sigla: 'PR' },
        { nome: 'Pernambuco', sigla: 'PE' },
        { nome: 'Piauí', sigla: 'PI' },
        { nome: 'Rio de Janeiro', sigla: 'RJ' },
        { nome: 'Rio Grande do Norte', sigla: 'RN' },
        { nome: 'Rio Grande do Sul', sigla: 'RS' },
        { nome: 'Rondônia', sigla: 'RO' },
        { nome: 'Roraima', sigla: 'RR' },
        { nome: 'Santa Catarina', sigla: 'SC' },
        { nome: 'São Paulo', sigla: 'SP' },
        { nome: 'Sergipe', sigla: 'SE' },
        { nome: 'Tocantins', sigla: 'TO' },
      ],
      contratantes: [
        {
          id: '',
          nome: '',
          cpf: '',
          rg: '',
          cnpj: '',
          endereco: '',
          telCel: '',
          telRes: '',
          bairro: '',
          numero: 0,
          email: '',
          cidade: '',
          estado: '',
          CEP: '',
        },
      ],
      contratada: {
        representante: '',
        telefone: '',
        estado: '',
        cidade: '',
        rua: '',
        cpf: '',
        email: '',
      },
      produtosEspecificados: '',
      turma: {
        nome: '',
        turno: '',
        curso: '',
        faculdade: '',
        estado: '',
        mes: '',
        ano: '',
        fullDate: '',
      },
      valores: {
        total: 0,
        multa: 0,
        totalExtenso: '',
        parcelas: [
          {
            valor: 0,
            data: '',
          },
        ],
      },
      tipoPessoas: [],
      proposta: {
        numero: '',
      },
      testemunhas: [
        {
          nome: '',
          tel: '',
          cidade: '',
          estado: '',
          bairro: '',
          endereco: '',
          CEP: '',
          rg: '',
          cpf: '',
          email: '',
        },
        {
          nome: '',
          tel: '',
          cidade: '',
          estado: '',
          bairro: '',
          endereco: '',
          CEP: '',
          rg: '',
          cpf: '',
          email: '',
        },
      ],
      procurandoCepTestemunha: [false, false],
      tipo: 'alpha',
      cidade: '',
      ref_cliente: '',
      dt_chegada: '',
      ano_corrente: '',
      extraFile: undefined,
      infoCidadeMetrics: {},
      problemasComDatas: false,
      finalizarOrcamento: false,
      renderizarContrato: false,
      gerarDownload: false,
      salvarOrcamento: false,
      dataHjExtenso: new Date().toLocaleString('pt-br', {
        weekday: 'long',
        month: 'long',
        year: 'numeric',
        day: 'numeric',
      }),
      individual: false,
      procurandoCep: false,
      numContrato: '',
      botaoDownload: true,
      tabsControle: 'contratante',
      contratoSalvo: {},
    };
  }

  componentWillMount() {
    axios.defaults.headers.common = {
      Authorization: sessionStorage.getItem('token'),
    };
  }

  criarLog(tipo, erro, mensagem) {
    new TelegramLog().novo(tipo, [
      JSON.stringify(erro),
      mensagem,
      `Orçamento nº: ${this.props.orcamento.id}`,
      `usuarioLogado: ${
        JSON.parse(sessionStorage.getItem('usuarioLogado'))[0].Login
      }`,
    ]);
  }

  async componentDidMount() {
    let usuarioLogado = JSON.parse(sessionStorage.getItem('usuarioLogado'))[0],
      orcamento = this.props.orcamento,
      cliente = orcamento.cliente,
      {
        valores,
        proposta,
        turma,
        cidade,
        contratantes,
        contratada,
      } = this.state,
      hj = this.splitReverseJoinToEnglish(this.toLocalePt(new Date())),
      ano_corrente = String(new Date().getFullYear()).substring(2, 4);

    if (cliente.contatos.length > 0) {
      orcamento.observacao = orcamento.cliente.Obs;

      valores.total = Number(orcamento.precoTotal.toFixed(2));
      valores.multa = orcamento.precoTotal * 0.3;
      valores.totalExtenso = extenso(
        orcamento.precoTotal.toLocaleString('pt-BR')
      );
      valores.parcelas[0].valor = valores.total;
      valores.parcelas[0].data = hj;

      proposta.numero = orcamento.id;
      //turma
      turma.curso = cliente.curso;
      turma.faculdade = cliente.Instituicao;
      turma.estado = this.state.estadosJson.find((estado) => {
        return estado.sigla === cliente.SiglaEstado;
      });
      turma.estado = turma.estado !== undefined ? turma.estado.nome : '';
      //cidade
      cidade = cliente.Cidade;
      //contratante
      contratantes[0].id = cliente.contatos[0].idContato;
      contratantes[0].nome = cliente.contatos[0].Nome;
      contratantes[0].endereco = cliente.Endereco;
      contratantes[0].cpf = cliente.contatos[0].CPF;
      contratantes[0].rg = cliente.contatos[0].RG;
      contratantes[0].telCel = cliente.contatos[0].Celular;
      contratantes[0].telRes = cliente.contatos[0].Fixo;
      contratantes[0].email = cliente.contatos[0].email;
      contratada.representante = orcamento.NomeVendedor;
      contratada.estado = usuarioLogado.estado;
      contratada.telefone = usuarioLogado.Telefone;
      contratada.cidade = usuarioLogado.cidade;
      contratada.rua = usuarioLogado.endereco;
      contratada.email = usuarioLogado.Email;
      contratada.cpf = usuarioLogado.cpf;
      await this.gerarNumeroContrato(orcamento.cliente.numContrato);
      this.setState(
        {
          orcamento,
          cliente,
          cidade,
          contratantes,
          contratada,
          valores,
          individual: orcamento.pagamentoIndividual,
          ano_corrente,
          renderizarContrato: true,
        },
        () => {
          axios
            .get(`${REQUEST_URL}/contrato_orcamento/${orcamento.id}`)
            .then((response) => {
              this.carregarSalvo(response.data);
            })
            .catch((erro) => {
              this.criarLog(
                'INFO',
                erro,
                'Não existe nenhum contrato cadastrado para este orçamento!'
              );
            });
        }
      );
    }
  }

  componentDidUpdate() {
    this.bloquearInputsParcela();
  }

  carregarSalvo(contrato) {
    let contratantes = this.state.contratantes,
      tipoPessoas = ['fisica'];
    contratantes[0].id = this.state.orcamento.cliente.contatos[0].idContato;
    contratantes[0].nome = contrato.c1_nome;
    contratantes[0].endereco = contrato.c1_endereco;
    contratantes[0].cidade = contrato.c1_cep !== '' ? contrato.c1_cidade : '';
    contratantes[0].estado = contrato.c1_cep !== '' ? contrato.c1_estado : '';
    contratantes[0].bairro = contrato.c1_bairro;
    contratantes[0].CEP = contrato.c1_cep;
    contratantes[0].cpf = contrato.c1_cpf;
    contratantes[0].rg = contrato.c1_rg;
    contratantes[0].numero = contrato.c1_numero;
    contratantes[0].email = contrato.c1_email;
    contratantes[0].telCel = contrato.c1_telcel;
    contratantes[0].telRes = contrato.c1_telres;
    contratantes[0].cnpj = contrato.c1_cnpj;
    if (contratantes[0].cnpj !== null && contratantes[0].cnpj !== '') {
      tipoPessoas = ['juridica'];
    }

    if (contrato.qtdContratantes > 1) {
      let contratante2 = {
        id: this.state.orcamento.cliente.contatos[1].idContato,
        nome: contrato.c2_nome,
        endereco: contrato.c2_endereco,
        cidade: contrato.c2_cidade,
        estado: contrato.c2_estado,
        bairro: contrato.c2_bairro,
        numero: contrato.c2_numero,
        CEP: contrato.c2_cep,
        cpf: contrato.c2_cpf,
        rg: contrato.c2_rg,
        email: contrato.c2_email,
        telCel: contrato.c2_telcel,
        telRes: contrato.c2_telres,
        cnpj: contrato.c2_cnpj,
      };
      contratantes.push(contratante2);
      if (contratante2.cnpj !== null && contratante2.cnpj !== '') {
        tipoPessoas.push('juridica');
      } else {
        tipoPessoas.push('fisica');
      }
    }
    let valores = this.state.valores;
    // Usa o precoTotal atual do orçamento, ignorando o valorTotal salvo no banco,
    // para garantir que alterações nas quantidades da proposta sejam refletidas no contrato.
    const valorAtual = valores.total;
    valores.multa = valorAtual * 0.3;
    valores.totalExtenso = extenso(valorAtual.toLocaleString('pt-BR'));

    let parcelas = [];
    if (contrato.parcelas.length === 0) {
      for (let i = 0; i < contrato.qtdParcelas; i++) {
        parcelas.push({
          valor: '500',
          data: this.splitReverseJoinToEnglish(this.toLocalePt(new Date())),
        });
      }
      let precoParcela = contrato.valorTotal / contrato.qtdParcelas;
      parcelas.forEach((parcela) => {
        parcela.valor = precoParcela;
      });
    } else {
      contrato.parcelas.forEach((parcela) => {
        parcelas.push({
          id: parcela.id,
          valor: parcela.valor,
          data: parcela.data.split('T')[0],
        });
      });
    }
    valores.parcelas = parcelas;
    let tipo = this.state.tipo;
    tipo = contrato.tipoContrato;

    let contratada = this.state.contratada;
    contratada.representante = contrato.r_nome;
    contratada.email = contrato.r_email;
    contratada.cidade = contrato.r_cidade;
    contratada.estado = contrato.r_estado;
    contratada.cpf = contrato.r_cpf;
    contratada.rua = contrato.r_rua;
    contratada.telefone = contrato.r_telefone;

    let turma = this.state.turma;

    if (contrato.data !== undefined || contrato.data !== null) {
      turma.fullDate = contrato.data.split('T')[0];
    } else {
      turma.fullDate = `${contrato.t_anoColacao}-${
        MES_EXTENSO[contrato.t_mesColacao]
      }-01`;
    }

    turma.ano = contrato.t_anoColacao;
    turma.mes = contrato.t_mesColacao;

    // Garante que o mês seja calculado a partir da fullDate caso esteja vazio
    if (!turma.mes && turma.fullDate) {
      const mesExtenso = Object.keys(MES_EXTENSO);
      turma.mes = mesExtenso[new Date(turma.fullDate).getMonth() + 1];
      turma.ano = new Date(turma.fullDate).getFullYear();
    }

    if (turma.estado === undefined) {
      turma.estado = '';
    }

    let testemunhas = this.state.testemunhas;
    testemunhas[0].nome = contrato.tes1_nome;
    testemunhas[0].tel = contrato.tes1_telefone;
    testemunhas[0].cidade = contrato.tes1_cidade;
    testemunhas[0].estado = contrato.tes1_estado || '';
    testemunhas[0].bairro = contrato.tes1_bairro || '';
    testemunhas[0].CEP = contrato.tes1_cep || '';
    testemunhas[0].endereco = contrato.tes1_endereco;
    testemunhas[0].rg = contrato.tes1_rg;
    testemunhas[0].cpf = contrato.tes1_cpf;
    testemunhas[0].email = contrato.tes1_email;
    testemunhas[1].nome = contrato.tes2_nome;
    testemunhas[1].tel = contrato.tes2_telefone;
    testemunhas[1].cidade = contrato.tes2_cidade;
    testemunhas[1].estado = contrato.tes2_estado || '';
    testemunhas[1].bairro = contrato.tes2_bairro || '';
    testemunhas[1].CEP = contrato.tes2_cep || '';
    testemunhas[1].endereco = contrato.tes2_endereco;
    testemunhas[1].rg = contrato.tes2_rg;
    testemunhas[1].email = contrato.tes2_email;
    testemunhas[1].cpf = contrato.tes2_cpf;

    let ano_corrente = this.state.ano_corrente;
    if (contrato.ano_corrente) {
      ano_corrente = contrato.ano_corrente;
    }
    this.setState({
      contratantes,
      valores,
      tipo,
      contratada,
      turma,
      testemunhas,
      ref_cliente: contrato.ref_cliente,
      dt_chegada: contrato.dt_chegada.split('T')[0],
      ano_corrente,
      tipoPessoas,
    });
  }

  async salvarContrato() {
    this.setState({ salvarOrcamento: true });
    if (!this.state.problemasComDatas) {
      let contrato = {
        c1_id: this.state.contratantes[0].id,
        c1_bairro: this.state.contratantes[0].bairro,
        c1_cep: this.state.contratantes[0].CEP,
        c1_cidade: this.state.contratantes[0].cidade,
        c1_cpf: this.state.contratantes[0].cpf,
        c1_email: this.state.contratantes[0].email,
        c1_endereco: this.state.contratantes[0].endereco,
        c1_estado: this.state.contratantes[0].estado,
        c1_nome: this.state.contratantes[0].nome,
        c1_numero: this.state.contratantes[0].numero,
        c1_rg: this.state.contratantes[0].rg,
        c1_telcel: this.state.contratantes[0].telCel,
        c1_telres: this.state.contratantes[0].telRes,
        c1_cnpj: this.state.contratantes[0].cnpj,

        orcamento: this.props.orcamento.id,
        qtdContratantes: this.state.contratantes.length,
        qtdParcelas: this.state.valores.parcelas.length,
        qtdTestemunhas: this.state.testemunhas.length,

        r_email: this.state.contratada.email,
        r_cidade: this.state.contratada.cidade,
        r_estado: this.state.contratada.estado,
        r_cpf: this.state.contratada.cpf,
        r_nome: this.state.contratada.representante,
        r_rua: this.state.contratada.rua,
        r_telefone: this.state.contratada.telefone,
        t_anoColacao: this.state.turma.ano,
        t_mesColacao: this.state.turma.mes,
        tes1_cidade: this.state.testemunhas[0].cidade,
        tes1_estado: this.state.testemunhas[0].estado,
        tes1_bairro: this.state.testemunhas[0].bairro,
        tes1_cep: this.state.testemunhas[0].CEP,
        tes1_endereco: this.state.testemunhas[0].endereco,
        tes1_nome: this.state.testemunhas[0].nome,
        tes1_rg: this.state.testemunhas[0].rg,
        tes1_telefone: this.state.testemunhas[0].tel,
        tes1_cpf: this.state.testemunhas[0].cpf,
        tes1_email: this.state.testemunhas[0].email,
        tes2_cidade: this.state.testemunhas[1].cidade,
        tes2_estado: this.state.testemunhas[1].estado,
        tes2_bairro: this.state.testemunhas[1].bairro,
        tes2_cep: this.state.testemunhas[1].CEP,
        tes2_endereco: this.state.testemunhas[1].endereco,
        tes2_nome: this.state.testemunhas[1].nome,
        tes2_rg: this.state.testemunhas[1].rg,
        tes2_telefone: this.state.testemunhas[1].tel,
        tes2_cpf: this.state.testemunhas[1].cpf,
        tes2_email: this.state.testemunhas[1].email,
        data: this.state.turma.fullDate,
        tipoContrato: this.state.tipo,
        valorTotal: this.state.valores.total,
      };
      if (this.state.contratantes.length > 1) {
        contrato.c2_id = this.state.contratantes[1].id;
        contrato.c2_bairro = this.state.contratantes[1].bairro;
        contrato.c2_cep = this.state.contratantes[1].CEP;
        contrato.c2_cidade = this.state.contratantes[1].cidade;
        contrato.c2_cpf = this.state.contratantes[1].cpf;
        contrato.c2_email = this.state.contratantes[1].email;
        contrato.c2_endereco = this.state.contratantes[1].endereco;
        contrato.c2_estado = this.state.contratantes[1].estado;
        contrato.c2_nome = this.state.contratantes[1].nome;
        contrato.c2_numero = this.state.contratantes[1].numero;
        contrato.c2_rg = this.state.contratantes[1].rg;
        contrato.c2_telcel = this.state.contratantes[1].telCel;
        contrato.c2_telres = this.state.contratantes[1].telRes;
        contrato.c2_cnpj = this.state.contratantes[1].cnpj;
      }

      contrato.dt_chegada = this.state.dt_chegada;
      contrato.ref_cliente = this.state.ref_cliente;
      if (contrato.ref_cliente !== '') {
        this.gerarNumeroContrato(contrato.ref_cliente);
      }
      // Atualizar contato dos contratantes
      axios
        .put(
          `${REQUEST_URL}/cliente/contato/${this.state.contratantes[0].id}`,
          {
            Nome: contrato.c1_nome,
            email: contrato.c1_email,
            Celular: contrato.c1_telcel,
            Fixo: contrato.c1_telres,
            CPF: contrato.c1_cpf,
            RG: contrato.c1_rg,
            CNPJ: contrato.c1_cnpj,
            ContatoPrinc: 'SIM',
          }
        )
        .then(async () => {
          if (this.state.contratantes.length > 1) {
            if (this.state.contratantes[1].id !== undefined) {
              axios
                .put(
                  `${REQUEST_URL}/cliente/contato/${this.state.contratantes[1].id}`,
                  {
                    Nome: contrato.c2_nome,
                    email: contrato.c2_email,
                    Celular: contrato.c2_telcel,
                    Fixo: contrato.c2_telres,
                    CPF: contrato.c2_cpf,
                    RG: contrato.c2_rg,
                    CNPJ: contrato.c2_cnpj,
                    ContatoPrinc: 'NAO',
                  }
                )
                .catch((erro) => {
                  this.criarLog(
                    'ERROR',
                    erro,
                    'Não foi possível atualizar as informações de contato do contratante 2'
                  );
                  toast.error(
                    'Não foi possível atualizar as informações de contato do contratante 2'
                  );
                });
            } else {
              axios
                .post(`${REQUEST_URL}/cliente/contato/`, {
                  Nome: contrato.c2_nome,
                  email: contrato.c2_email,
                  Celular: contrato.c2_telcel,
                  Fixo: contrato.c2_telres,
                  CPF: contrato.c2_cpf,
                  RG: contrato.c2_rg,
                  IdCliente: this.props.orcamento.cliente.codCliente,
                  CNPJ: contrato.c2_cnpj,
                  ContatoPrinc: 'NAO',
                })
                .then((clienteCadastrado) => {
                  contrato.c2_id = clienteCadastrado.data.insertId;
                  let contratantes = Object.assign([], this.state.contratantes);
                  contratantes[1].id = clienteCadastrado.data.insertId;
                  this.setState({ contratantes });
                })
                .catch((erro) => {
                  this.criarLog(
                    'ERROR',
                    erro,
                    'Não foi possível cadastrar as informações de contato do contratante 2'
                  );
                  toast.error(
                    'Não foi possível cadastrar as informações de contato do contratante 2'
                  );
                });
            }
          }
          contrato.ano_corrente = parseInt(this.state.ano_corrente);
          axios
            .post(`${REQUEST_URL}/contrato_orcamento`, { contrato })
            .then(async (response) => {
              this.setState({
                salvarOrcamento: false,
                botaoDownload: false,
                contratoSalvo: contrato,
              });
              await this.salvarParcelas();
              toast.success('Contrato atualizado com sucesso!');
            })
            .catch((erro) => {
              this.criarLog(
                'ERROR',
                erro,
                'Erro ao salvar o contrato. Tente novamente!'
              );
              toast.error('Erro ao salvar o contrato. Tente novamente!');
              this.setState({ salvarOrcamento: false });
            });
        })
        .catch((erro) => {
          this.criarLog(
            'ERROR',
            erro,
            'Não foi possível atualizar as informações de contato do contratante 1'
          );
          toast.error(
            'Não foi possível atualizar as informações de contato do contratante 1'
          );
          this.setState({ salvarOrcamento: false });
        });
    }
  }

  async gerarNumeroContrato(numContrato = null) {
    if (numContrato === null) {
      await axios
        .get(REQUEST_URL + '/orcamentos/numContrato/last')
        .then(async (response) => {
          let id = response.data.length > 0 ? response.data[0].idOrc : -1,
            numContrato =
              response.data.length > 0 ? response.data[0].numContrato : null;
          if (id !== this.props.orcamento.id) {
            if (numContrato === null) {
              numContrato = 30000;
            } else {
              await axios
                .post(`${URL_CONTRATO_API}/num-contract`)
                .then((response) => {
                  numContrato = response.data.contract;
                })
                .catch((erro) => {
                  this.criarLog(
                    'ERROR',
                    erro,
                    'Erro ao gerar o número do contrato deste orçamento pela API de contratos!'
                  );
                  toast.error(
                    'Erro ao gerar o número do contrato deste orçamento'
                  );
                });
            }
            await axios
              .put(
                REQUEST_URL +
                  '/orcamento/numContrato/' +
                  this.props.orcamento.id,
                { numContrato: numContrato }
              )
              .then((response) => {
                let orcamento = Object.assign({}, this.props.orcamento);
                orcamento.cliente.numContrato = numContrato;
                this.setState({ orcamento, numContrato });
                this.props.atualizarNumeroContrato(numContrato);
              })
              .catch((erro) => {
                this.criarLog(
                  'ERROR',
                  erro,
                  'Erro ao atualizar o número do contrato'
                );
                toast.error(
                  'Erro ao gerar o número do contrato deste orçamento'
                );
              });
          } else {
            let orcamento = Object.assign({}, this.props.orcamento);
            this.setState({ orcamento, numContrato });
            this.props.atualizarNumeroContrato(numContrato);
            axios
              .put(
                `${REQUEST_URL}/orcamento/${this.props.orcamento.id}/numContrato`,
                { numContrato: numContrato }
              )
              .catch((erro) => {
                this.criarLog(
                  'ERROR',
                  erro,
                  'Erro ao atualizar o número do contrato'
                );
              });
          }
        })
        .catch((erro) => {
          this.criarLog('ERROR', erro, 'Erro ao consultar o último contrato');
          toast.error('Erro ao consultar o último contrato');
        });
    } else {
      let orcamento = Object.assign({}, this.state.orcamento);
      this.setState({ orcamento, numContrato });
      this.props.atualizarNumeroContrato(numContrato);
      axios
        .put(
          `${REQUEST_URL}/orcamento/${this.props.orcamento.id}/numContrato`,
          { numContrato: numContrato }
        )
        .catch((erro) => {
          this.criarLog(
            'ERROR',
            erro,
            'Erro ao atualizar o número do contrato'
          );
        });
    }
  }

  salvarParcelas() {
    let novasParcelas = this.state.valores.parcelas;
    novasParcelas.forEach((parcela, i) => {
      if (parcela.id !== undefined) {
        axios
          .put(`${REQUEST_URL}/contrato/parcela/${parcela.id}`, parcela)
          .catch((erro) => {
            this.criarLog(
              'ERROR',
              erro,
              `Erro ao alterar as informações da parcela ${i + 1}!`
            );
            toast.error(`Erro ao alterar as informações da parcela ${i + 1}!`);
          });
      } else {
        axios
          .get(`${REQUEST_URL}/contrato_orcamento/${this.state.orcamento.id}`)
          .then((data) => {
            parcela.contrato = data.data.id;
            axios
              .post(`${REQUEST_URL}/contrato/parcela/`, parcela)
              .then((data) => {
                parcela.id = data.data.insertId;
              })
              .catch((erro) => {
                this.criarLog(
                  'ERROR',
                  erro,
                  `Erro ao cadastrar a parcela ${i + 1}`
                );
                toast.error(`Erro ao cadastrar a parcela ${i + 1}!`);
              });
          })
          .catch((erro) => {
            this.criarLog(
              'ERROR',
              erro,
              'Não é possível listar as parcelas de um contrato inexistente!'
            );
            toast.error(
              `Não é possível listar as parcelas de um contrato inexistente!`
            );
          });
      }
    });
    this.setState({
      valores: { ...this.state.valores, parcelas: novasParcelas },
    });
  }

  formatPayload() {
    return {
      contractNumber: this.state.numContrato.toString(),
      proposalNumber: this.state.proposta.numero.toString(),
      isIndividualPayment: this.state.orcamento.pagamentoIndividual,
      extraPdf: this.state.extraFile,
      closingDate: new Date().toLocaleDateString('pt-BR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
      contractingParties: this.state.contratantes.map((contratante) => ({
        name: contratante.nome,
        cpf: contratante.cpf ? contratante.cpf : contratante.cnpj,
        rg: Boolean(contratante.rg) ? contratante.rg : null,
        address: contratante.numero
          ? `${contratante.endereco}, ${contratante.numero}`
          : contratante.endereco,
        neighborhood: contratante.bairro,
        city: contratante.cidade,
        state: contratante.estado,
        zip: contratante.CEP,
        phone: Boolean(contratante.telRes) ? contratante.telRes : null,
        email: contratante.email,
        cellphone: contratante.telCel,
      })),
      seller: {
        name: this.state.contratada.representante,
        cpf: this.state.contratada.cpf,
        email: this.state.contratada.email,
        cellphone: this.state.contratada.telefone,
        city: this.state.contratada.cidade,
        state: this.state.contratada.estado,
        addressStreet: this.state.contratada.rua,
      },
      academicEvent: {
        course: this.state.turma.curso,
        university: this.state.turma.faculdade,
        state: this.state.turma.estado,
        month: this.state.turma.mes.toString(),
        year: this.state.turma.ano.toString(),
        graduationDate: this.state.turma.fullDate,
      },
      payment: {
        amountInWords: extenso(
          this.state.valores.total.toLocaleString('pt-BR')
        ),
        totalAmount: this.state.valores.total.toString(),
        installments: this.state.valores.parcelas.map((parcela) => ({
          value: parcela.valor.toString(),
          date: parcela.data,
        })),
      },
      witnesses: this.state.testemunhas.map((testemunha) => ({
        name: testemunha.nome,
        cellphone: testemunha.tel,
        email: testemunha.email,
        city: testemunha.cidade,
        address: testemunha.endereco,
        cpf: testemunha.cpf,
      })),
      proposal: this.props.jsonProposta,
    };
  }

  jsonToFormData(obj, form, namespace) {
    const fd = form || new FormData();

    for (let property in obj) {
      if (!obj.hasOwnProperty(property)) continue;
      const formKey = namespace ? `${namespace}[${property}]` : property;
      const value = obj[property];

      if (value instanceof Date) {
        fd.append(formKey, value.toISOString());
      } else if (value instanceof File) {
        fd.append(formKey, value);
      } else if (typeof value === 'object' && value !== null) {
        this.jsonToFormData(value, fd, formKey);
      } else if (typeof value === 'boolean') {
        fd.append(formKey, String(Number(value)));
      } else {
        fd.append(formKey, String(value));
      }
    }

    return fd;
  }

  async downloadProposta() {
    let contratoValidado = this.validarContrato();

    if (contratoValidado === true) {
      const payload = this.formatPayload();
      if (payload.extraPdf === undefined) {
        delete payload.extraPdf;
      }
      const formData = this.jsonToFormData(payload);

      axios
        .post(`${URL_NEW_MAPA_API}/contract/preview`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json',
            Authorization:
              'Bearer 3bca4df63f1cc72e4c8ad364a5d426f77e65f5084b40be712cf0bc4ed34ac61e',
          },
        })
        .then((response) => {
          if (window.confirm('Abrir PDF em nova aba?')) {
            window.open(response.data.url, '_blank');
          }
        })
        .catch((erro) => {
          new TelegramLog().novo('ERROR', [
            '\nDOWNLOAD DO CONTRATO',
            `\n${erro.response.data.message}`,
            `\n${JSON.parse(sessionStorage.getItem('usuarioLogado'))[0].Login}`,
          ]);
          toast.error('Não foi possível fazer o download do contrato!');
        });
    } else {
      toast.error(contratoValidado);
    }
  }

  limparHelpBlock() {
    document.querySelectorAll('.helpBlock').forEach(function(el) {
      el.remove();
    });
  }

  adicionarSpan(mensagem) {
    let span = document.createElement('span');
    span.textContent = mensagem;
    span.classList.add('helpBlock');
    return span;
  }

  validarContrato() {
    this.limparHelpBlock();
    let contratantes = this.state.contratantes,
      turma = this.state.turma,
      testemunhas = this.state.testemunhas,
      representante = this.state.contratada,
      invalido = true;
    // Validar contratantes
    contratantes.forEach((contratante, i) => {
      let campos = Object.keys(contratante);
      campos.forEach((campo) => {
        let input = document.querySelector(`#c${i}_${campo}`);
        if (campo.indexOf('telRes') === -1 && campo.indexOf('rg') === -1) {
          if (input !== null && !input.checkValidity()) {
            invalido = `Há um problema nos dados do contratante ${i + 1}!`;
            input
              .closest('div')
              .appendChild(this.adicionarSpan(input.validationMessage));
          }
        }
      });
    });
    // Validar turma
    if (invalido) {
      let campos = Object.keys(turma);
      campos.forEach((campo) => {
        let input = document.querySelector(`#t_${campo}`);
        if (
          campo.indexOf('nome') === -1 &&
          campo.indexOf('turno') === -1 &&
          campo.indexOf('fullDate') === -1
        ) {
          if (input !== null && !input.checkValidity()) {
            invalido = 'Há um problema nos dados da turma!';
            input
              .closest('div')
              .appendChild(this.adicionarSpan(input.validationMessage));
          }
        }
        // Validação personalizada para a data de colação
        if (
          campo === 'fullDate' &&
          (turma[campo] === '' ||
            this.splitReverseJoinToEnglish(
              this.toLocalePt(new Date(turma[campo]))
            ) <= this.splitReverseJoinToEnglish(this.toLocalePt(new Date())))
        ) {
          invalido = 'Há um problema nos dados da turma!';
          input
            .closest('div')
            .appendChild(
              this.adicionarSpan(
                'A data da colação não pode menor ou igual ao dia de hoje!'
              )
            );
        }
      });
      // Validação do campo cidade, que não está no json de turma
      if (invalido) {
        let input = document.querySelector(`#t_cidade`);
        if (input !== null && !input.checkValidity()) {
          invalido = 'Há um problema nos dados da turma!';
          input
            .closest('div')
            .appendChild(this.adicionarSpan(input.validationMessage));
        }
      }
    }
    // Validar testemunhas
    if (invalido) {
      testemunhas.forEach((testemunha, i) => {
        let campos = Object.keys(testemunha);
        campos.forEach((campo) => {
          let input = document.querySelector(`#test${i}_${campo}`);
          if (campo === 'cpf') {
            if (!document.querySelector(`#test${i}_cpf`).checkValidity()) {
              invalido = `É necessário informar o CPF da testemunha ${i + 1}!`;
              input
                .closest('div')
                .appendChild(this.adicionarSpan(input.validationMessage));
            }
          } else if (input !== null && !input.checkValidity()) {
            invalido = `Há um problema nos dados da testemunha ${i + 1}!`;
            input
              .closest('div')
              .appendChild(this.adicionarSpan(input.validationMessage));
          }
        });
      });
    }
    //Validar representante
    if (invalido) {
      let campos = Object.keys(representante);
      campos.forEach((campo) => {
        let input = document.querySelector(`#cont_${campo}`);
        if (input !== null && !input.checkValidity()) {
          invalido = 'Há um problema nos dados do representante!';
          input
            .closest('div')
            .appendChild(this.adicionarSpan(input.validationMessage));
        }
      });
    }
    return invalido;
  }

  splitReverseJoinToEnglish(data) {
    return data
      .split('/')
      .reverse()
      .join('-');
  }

  toLocalePt(data) {
    return data.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  }

  async addParcela() {
    let valores = Object.assign({}, this.state.valores),
      numParcelas = valores.parcelas.length,
      dataFormatura = new Date(this.state.turma.fullDate),
      ultimoDia = new Date(
        dataFormatura.getFullYear(),
        dataFormatura.getMonth() + 1,
        0
      ),
      diaUltima = new Date(
        new Date(valores.parcelas[valores.parcelas.length - 1].data).getTime()
      ),
      parcelaAtual = this.splitReverseJoinToEnglish(
        this.toLocalePt(new Date(diaUltima.setMonth(diaUltima.getMonth() + 1)))
      );

    let dataParcelaAtual = new Date(parcelaAtual);
    let diasParaFormatura = Math.ceil(
      (dataFormatura.getTime() - dataParcelaAtual.getTime()) /
        (1000 * 60 * 60 * 24)
    );

    if (
      numParcelas <= 11 &&
      dataParcelaAtual.getTime() <= ultimoDia.getTime() &&
      diasParaFormatura > 45
    ) {
      valores.parcelas.push({ valor: '', data: parcelaAtual });
      let precoParcela = valores.total / valores.parcelas.length;
      valores.parcelas.forEach((parcela) => {
        parcela.valor = Number(precoParcela.toFixed(2));
      });
      this.setState({ valores, botaoDownload: true });
    }
  }

  bloquearInputsParcela() {
    let inputs = document.querySelectorAll('.numero-parcela');
    if (inputs.length === 1) {
      inputs[inputs.length - 1].setAttribute('disabled', 'true');
    } else if (inputs.length > 1) {
      inputs[0].removeAttribute('disabled');
      inputs[inputs.length - 1].setAttribute('disabled', 'true');
      inputs[inputs.length - 2].removeAttribute('disabled');
    }
  }

  async removeParcela() {
    let valores = this.state.valores,
      deletou = true;
    if (valores.parcelas.length > 1) {
      if (valores.parcelas[valores.parcelas.length - 1].id !== undefined) {
        await axios
          .delete(
            `${REQUEST_URL}/contrato/parcela/${valores.parcelas[valores.parcelas.length - 1].id}`
          )
          .catch((erro) => {
            this.criarLog(
              'ERROR',
              erro,
              `Erro ao remover a parcela ${valores.parcelas.length}`
            );
            toast.error(`Erro ao remover a parcela ${valores.parcelas.length}`);
            deletou = false;
          });
      }
      if (deletou) {
        valores.parcelas.pop();
        let qtdParcelas = valores.parcelas.length,
          precoParcela = valores.total / qtdParcelas;
        valores.parcelas.forEach((parcela) => {
          parcela.valor = Number(precoParcela.toFixed(2));
        });
        this.setState({ valores, botaoDownload: true });
      }
    }
  }

  changeData(index, e) {
    let valores = this.state.valores;
    valores.parcelas[index].data = e.target.value;
    this.setState({ valores, botaoDownload: true });
  }

  validarData(el = undefined) {
    let dataFormatura = new Date(this.state.turma.fullDate),
      diaInicialLimite = this.splitReverseJoinToEnglish(
        this.toLocalePt(new Date())
      ),
      diaFinalLimite = new Date(
        dataFormatura.getFullYear(),
        dataFormatura.getMonth(),
        dataFormatura.getDate(),
        dataFormatura.getHours() + 3
      ),
      dataInserida =
        el === undefined
          ? this.state.valores.parcelas[this.state.valores.parcelas.length - 1]
              .data
          : el.target.value;
    diaFinalLimite = this.splitReverseJoinToEnglish(
      this.toLocalePt(
        new Date(diaFinalLimite.setMonth(diaFinalLimite.getMonth() - 1))
      )
    );
    if (dataInserida < diaInicialLimite) {
      toast.error('Datas retroativas não são permitidas!');
      this.setState({ problemasComDatas: true, salvarOrcamento: false });
    } else if (dataInserida > diaFinalLimite) {
      toast.error(
        'As parcelas só podem ser agendadas com até um mês antes da colação!'
      );
      this.setState({ problemasComDatas: true, salvarOrcamento: false });
    } else {
      this.setState({ problemasComDatas: false, salvarOrcamento: false });
    }
  }

  getCodCliente() {
    return this.state.orcamento.cliente.codCliente !== undefined
      ? this.state.orcamento.cliente.codCliente
      : this.state.orcamento.cliente.idCliente;
  }

  getCodVendedor() {
    return this.state.orcamento.cliente.codVendedor !== undefined
      ? this.state.orcamento.cliente.codVendedor
      : this.state.orcamento.cliente.Vendedor;
  }

  changeValorParcela(index, e) {
    let valores = this.state.valores;
    valores.parcelas[index].valor = Number(e.target.value);
    this.setState({ valores });
    let somaAteIndex = 0;
    valores.parcelas.forEach((parcela, i) => {
      if (i <= index) {
        somaAteIndex += parcela.valor;
      } else {
        let restante = valores.total - somaAteIndex;
        let qtdRestoParcelas = valores.parcelas.length - (index + 1);
        parcela.valor = (restante / qtdRestoParcelas).toFixed(2);
      }
    });
    this.setState({ valores, botaoDownload: true });
  }

  formatReal(n) {
    if (n !== undefined || n !== null) {
      return Number(
        Number(n)
          .toFixed(2)
          .toLocaleString('pt-BR')
      );
    }
  }

  async validarDocumento(documento) {
    if (documento !== true) {
      var validator = require('br-doc-validator');
      return await validator.documentValidatorProm(documento).then(
        () => {
          return true;
        },
        () => {
          return false;
        }
      );
    }
    return true;
  }

  addContratante() {
    let contratantes = this.state.contratantes,
      tipoPessoas = this.state.tipoPessoas;
    if (contratantes.length < 2) {
      contratantes.push({
        nome: '',
        cpf: '',
        rg: '',
        cnpj: '',
        endereco: '',
        telCel: '',
        telRes: '',
        bairro: '',
        email: '',
        cidade: '',
        estado: '',
        CEP: '',
      });
      tipoPessoas.push('fisica');
      this.setState({ contratantes, tipoPessoas, botaoDownload: true });
    }
  }

  removerContratante() {
    let contratantes = this.state.contratantes;
    if (contratantes.length > 1) {
      contratantes.pop();
      this.setState({ contratantes, botaoDownload: true });
    }
  }

  handleChangeContratantes(i, el) {
    let inputName = el.target.name,
      inputValue = el.target.value,
      contratantes = this.state.contratantes;

    contratantes[i][inputName] =
      inputName === 'email' ? inputValue.trim() : inputValue;
    this.setState({ contratantes, botaoDownload: true });
  }

  handleChangeTipoPessoas(i, e) {
    let inputValue = e.target.value,
      tipoPessoas = this.state.tipoPessoas,
      contratantes = this.state.contratantes;
    tipoPessoas[i] = inputValue;
    if (inputValue === 'fisica') {
      contratantes[i]['cnpj'] = '';
    } else {
      contratantes[i]['cpf'] = '';
      contratantes[i]['rg'] = '';
    }
    this.setState({ tipoPessoas, contratantes, botaoDownload: true });
  }

  handleChangeTestemunhas(i, el) {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    let testemunhas = this.state.testemunhas;
    testemunhas[i][inputName] = inputValue;
    this.setState({ testemunhas, botaoDownload: true });
  }

  async encontrarCidade(i, el) {
    let contratantes = this.state.contratantes,
      valor = contratantes[i]['CEP'];
    if (
      valor !== undefined &&
      valor.replace('-', '').replace('_', '').length === 8
    ) {
      this.setState({ procurandoCep: true });
      valor = valor.replace('-', '').replace(' ', '');
      await axios
        .post(`${REQUEST_URL}/encontrar-cidade`, { cep: valor })
        .then((data) => {
          data = data.data;
          contratantes[i]['estado'] = data.estado;
          contratantes[i]['cidade'] = data.cidade;
          contratantes[i]['bairro'] = data.bairro;
          contratantes[i]['endereco'] = data.endereco;
          this.setState({ procurandoCep: false, contratantes });

          if (
            data.estado.length === 0 ||
            data.cidade.length === 0 ||
            data.bairro.length === 0 ||
            data.endereco.length === 0
          ) {
            toast.info(
              'Não encontramos as informações deste CEP. Por favor, preencha manualmente!'
            );

            if (data.estado.length === 0)
              document
                .querySelector(`#c${i}_estado`)
                .removeAttribute('disabled');
            if (data.cidade.length === 0)
              document
                .querySelector(`#c${i}_cidade`)
                .removeAttribute('disabled');
            if (data.bairro.length === 0)
              document
                .querySelector(`#c${i}_bairro`)
                .removeAttribute('disabled');
            if (data.endereco.length === 0)
              document
                .querySelector(`#c${i}_endereco`)
                .removeAttribute('disabled');
          }
        })
        .catch((erro) => {
          toast.error(erro);
          contratantes[i]['estado'] = '';
          contratantes[i]['cidade'] = '';
          contratantes[i]['bairro'] = '';
          contratantes[i]['endereco'] = '';
          document.querySelector(`#c${i}_estado`).removeAttribute('disabled');
          document.querySelector(`#c${i}_cidade`).removeAttribute('disabled');
          document.querySelector(`#c${i}_bairro`).removeAttribute('disabled');
          document.querySelector(`#c${i}_endereco`).removeAttribute('disabled');
          toast.info(
            'Não encontramos as informações deste CEP. Por favor, preencha manualmente!'
          );
          this.setState({ procurandoCep: false, contratantes });
        });
    }
  }

  async encontrarCidadeTestemunha(i) {
    let testemunhas = this.state.testemunhas,
      procurandoCepTestemunha = this.state.procurandoCepTestemunha,
      valor = testemunhas[i]['CEP'];
    if (
      valor !== undefined &&
      valor.replace('-', '').replace('_', '').length === 8
    ) {
      procurandoCepTestemunha[i] = true;
      this.setState({ procurandoCepTestemunha });
      valor = valor.replace('-', '').replace(' ', '');
      await axios
        .post(`${REQUEST_URL}/encontrar-cidade`, { cep: valor })
        .then((data) => {
          data = data.data;
          testemunhas[i]['estado'] = data.estado;
          testemunhas[i]['cidade'] = data.cidade;
          testemunhas[i]['bairro'] = data.bairro;
          testemunhas[i]['endereco'] = data.endereco;
          procurandoCepTestemunha[i] = false;
          this.setState({ procurandoCepTestemunha, testemunhas });

          if (
            data.estado.length === 0 ||
            data.cidade.length === 0 ||
            data.bairro.length === 0 ||
            data.endereco.length === 0
          ) {
            toast.info(
              'Não encontramos as informações deste CEP. Por favor, preencha manualmente!'
            );

            if (data.estado.length === 0)
              document
                .querySelector(`#test${i}_estado`)
                .removeAttribute('disabled');
            if (data.cidade.length === 0)
              document
                .querySelector(`#test${i}_cidade`)
                .removeAttribute('disabled');
            if (data.bairro.length === 0)
              document
                .querySelector(`#test${i}_bairro`)
                .removeAttribute('disabled');
            if (data.endereco.length === 0)
              document
                .querySelector(`#test${i}_endereco`)
                .removeAttribute('disabled');
          }
        })
        .catch((erro) => {
          toast.error(erro);
          testemunhas[i]['estado'] = '';
          testemunhas[i]['cidade'] = '';
          testemunhas[i]['bairro'] = '';
          testemunhas[i]['endereco'] = '';
          procurandoCepTestemunha[i] = false;
          document.querySelector(`#test${i}_estado`).removeAttribute('disabled');
          document.querySelector(`#test${i}_cidade`).removeAttribute('disabled');
          document.querySelector(`#test${i}_bairro`).removeAttribute('disabled');
          document.querySelector(`#test${i}_endereco`).removeAttribute('disabled');
          toast.info(
            'Não encontramos as informações deste CEP. Por favor, preencha manualmente!'
          );
          this.setState({ procurandoCepTestemunha, testemunhas });
        });
    }
  }

  reabrirOrcamento() {
    this.props.history.push({
      pathname: '/orcamento',
      state: {
        idOrc: this.state.proposta.numero,
        cliente: this.state.cliente,
      },
    });
  }

  handleChangeFullDate() {
    let turma = Object.assign({}, this.state.turma),
      mesExtenso = Object.keys(MES_EXTENSO);
    turma.mes = mesExtenso[new Date(turma.fullDate).getMonth() + 1];
    turma.ano = new Date(turma.fullDate).getFullYear();
    this.setState({ turma: turma, botaoDownload: true });
  }

  async finalizarOrcamento() {
    this.setState({ finalizarOrcamento: true });

    try {
      const contratoSalvo = this.state.contratoSalvo;
      const downloadLiberado = this.validarContrato();

      if (downloadLiberado !== true) {
        toast.error(downloadLiberado);
        return;
      }

      const documentoValidado1 = await this.validarDocumento(
        contratoSalvo.c1_cpf ? contratoSalvo.c1_cpf : contratoSalvo.c1_cnpj
      );

      const documentoValidado2 = await this.validarDocumento(
        contratoSalvo.c2_cpf
          ? contratoSalvo.c2_cpf
          : contratoSalvo.c2_cnpj
          ? contratoSalvo.c2_cnpj
          : true
      );

      if (!documentoValidado1) {
        toast.error(
          `${contratoSalvo.c1_cpf ? 'CPF' : 'CNPJ'} do contratante 1 inválido!`
        );
        return;
      }

      if (!documentoValidado2) {
        toast.error(
          `${
            contratoSalvo.c2_cpf ? 'CPF' : 'CNPJ'
          } do contratante 2 é inválido!`
        );
        return;
      }

      const payload = this.formatPayload();
      if (payload.extraPdf === undefined) {
        delete payload.extraPdf;
      }
      const formData = this.jsonToFormData(payload);

      await axios.post(`${URL_NEW_MAPA_API}/signature/send`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          Authorization:
            'Bearer 3bca4df63f1cc72e4c8ad364a5d426f77e65f5084b40be712cf0bc4ed34ac61e',
        },
      });

      this.props.updateState({
        status: 'Contrato Gerado',
        numero: this.state.orcamento.cliente.numContrato,
        dataFormatura: this.state.turma.fullDate,
        anoCorrente: this.state.ano_corrente,
      });

      this.props.onCloseModal(false);
    } catch (erro) {
      const storagedUser = sessionStorage.getItem('usuarioLogado');
      const parsedUser = storagedUser
        ? JSON.parse(storagedUser)[0].Login
        : 'Usuário desconhecido';

      new TelegramLog().novo('ERROR', [
        `\nINICIAR ASSINATURAS - ${this.state.orcamento.cliente.numContrato}`,
        `\n${erro.response.data.message || erro.message}`,
        `\n${parsedUser}`,
      ]);

      toast.error('Não foi possível iniciar o processo de assinaturas!');
    } finally {
      this.setState({ finalizarOrcamento: false });
    }
  }

  render() {
    return (
      <div>
        {this.state.renderizarContrato ? (
          <React.Fragment>
            <Nav tabs>
              <NavItem
                onClick={() => this.setState({ tabsControle: 'contratante' })}
              >
                <NavLink active={this.state.tabsControle === 'contratante'}>
                  Contratantes
                </NavLink>
              </NavItem>
              <NavItem
                onClick={() => this.setState({ tabsControle: 'representante' })}
              >
                <NavLink active={this.state.tabsControle === 'representante'}>
                  Representante
                </NavLink>
              </NavItem>
              <NavItem
                onClick={() => this.setState({ tabsControle: 'testemunhas' })}
              >
                <NavLink active={this.state.tabsControle === 'testemunhas'}>
                  Testemunhas
                </NavLink>
              </NavItem>
              <NavItem
                onClick={() => this.setState({ tabsControle: 'pagamento' })}
              >
                <NavLink active={this.state.tabsControle === 'pagamento'}>
                  Pagamento
                </NavLink>
              </NavItem>
              <NavItem
                onClick={() => this.setState({ tabsControle: 'modelo' })}
              >
                <NavLink active={this.state.tabsControle === 'modelo'}>
                  Configurações
                </NavLink>
              </NavItem>
            </Nav>

            <div
              name='Outras opções'
              hidden={!(this.state.tabsControle === 'modelo')}
              style={styleTabBody}
            >
              <br />
              <div className='row'>
                <div className='col-sm-12 col-md-8'>
                  <label>Data de chegada</label>
                  <input
                    type='date'
                    className='form-control form-group'
                    value={this.state.dt_chegada}
                    onChange={(e) => {
                      this.setState({
                        dt_chegada: e.target.value,
                        botaoDownload: true,
                      });
                    }}
                  />
                </div>
                <div className='col-sm-12 col-md-4'>
                  <label>Ano corrente</label>
                  <input
                    type='text'
                    className='form-control form-group'
                    value={this.state.ano_corrente}
                    onChange={(e) => {
                      this.setState({
                        ano_corrente: e.target.value,
                        botaoDownload: true,
                      });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-md-6'>
                  <label>Adicionar arquivos ao contrato</label>
                  <input
                    type='file'
                    onChange={(e) =>
                      this.setState({
                        extraFile: e.target.files[0],
                        botaoDownload: true,
                      })
                    }
                  />
                </div>
              </div>
              <label>Referência do cliente</label>
              <input
                type='text'
                className='form-control col-sm-12 col-md-6 form-group'
                value={this.state.ref_cliente}
                onChange={(e) => {
                  this.setState({
                    ref_cliente: e.target.value,
                    botaoDownload: true,
                  });
                }}
              />
            </div>
            <div
              name='contratante'
              hidden={!(this.state.tabsControle === 'contratante')}
              style={styleTabBody}
            >
              <br />
              <button
                className='btn btn-info btn-sm'
                onClick={this.removerContratante.bind(this)}
              >
                <i className='fas fa-minus'></i>
              </button>
              {' ' + this.state.contratantes.length + ' '}
              <button
                className='btn btn-info btn-sm'
                onClick={this.addContratante.bind(this)}
              >
                <i className='fas fa-plus'></i>
              </button>
              {this.state.contratantes.map((contratante, i) => (
                <div key={i}>
                  <br />
                  <h5>Contratante {i + 1}</h5>
                  <label>
                    <input
                      type='radio'
                      checked={this.state.tipoPessoas[i] !== 'juridica'}
                      value='fisica'
                      name={'tipoPessoa' + i}
                      onClick={this.handleChangeTipoPessoas.bind(this, i)}
                    />{' '}
                    Pessoa física
                  </label>
                  <label style={{ marginLeft: 5 }}>
                    <input
                      type='radio'
                      checked={this.state.tipoPessoas[i] === 'juridica'}
                      value='juridica'
                      name={'tipoPessoa' + i}
                      onClick={this.handleChangeTipoPessoas.bind(this, i)}
                    />{' '}
                    Pessoa jurídica
                  </label>
                  <div className='row form-group'>
                    <div className='col-sm-12 col-md-6'>
                      <label>* Nome</label>
                      <input
                        type='text'
                        id={`c${i + 1}_nome`}
                        name='nome'
                        className='form-control'
                        value={contratante.nome}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-md-6'>
                      <label>* E-mail</label>
                      <input
                        type='email'
                        id={`c${i + 1}_email`}
                        name='email'
                        className='form-control'
                        value={contratante.email}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        required
                      />
                    </div>
                  </div>
                  <div className='row form-group'>
                    {this.state.tipoPessoas[i] === 'juridica' ? (
                      <div className='col-sm-12 col-md-6'>
                        <label>* CNPJ</label>
                        <InputMask
                          name='cnpj'
                          id={`c${i}_cnpj`}
                          className='form-control'
                          mask='99.999.999/9999-99'
                          value={contratante.cnpj}
                          onChange={this.handleChangeContratantes.bind(this, i)}
                          required
                        />
                      </div>
                    ) : (
                      <div className='col-sm-12 col-md-6'>
                        <div className='row'>
                          <div className='col-sm-12 col-md-6'>
                            <label>* CPF</label>
                            <InputMask
                              name='cpf'
                              id={`c${i}_cpf`}
                              className='form-control'
                              mask='999.999.999-99'
                              value={contratante.cpf}
                              onChange={this.handleChangeContratantes.bind(
                                this,
                                i
                              )}
                              required
                            />
                          </div>
                          <div className='col-sm-12 col-md-6'>
                            <label>RG</label>
                            <input
                              type='text'
                              name='rg'
                              id={`c${i}_rg`}
                              className='form-control'
                              maxLength={15}
                              value={contratante.rg}
                              onChange={this.handleChangeContratantes.bind(
                                this,
                                i
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className='col-sm-12 col-md-3'>
                      <label>Telefone Residencial</label>
                      <InputMask
                        name='telRes'
                        className='form-control'
                        mask='(99) 9999 9999'
                        value={contratante.telRes}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                      />
                    </div>
                    <div className='col-sm-12 col-md-3'>
                      <label>* Telefone Celular</label>
                      <InputMask
                        name='telCel'
                        id={`c${i}_telCel`}
                        className='form-control'
                        mask='(99) 99999 9999'
                        value={contratante.telCel}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        required
                      />
                    </div>
                  </div>
                  <div className='row form-group'>
                    <div className='col-sm-12 col-md-3'>
                      <label>* CEP</label>
                      <InputGroup>
                        <InputMask
                          name='CEP'
                          id={`c${i}_CEP`}
                          className='form-control'
                          mask='99999-999'
                          value={contratante.CEP}
                          onChange={this.handleChangeContratantes.bind(this, i)}
                          required
                        />
                        {!this.state.procurandoCep ? (
                          <InputGroupAddon addonType='append'>
                            <Button
                              onClick={this.encontrarCidade.bind(this, i)}
                            >
                              Ok
                            </Button>
                          </InputGroupAddon>
                        ) : (
                          <InputGroupAddon addonType='append'>
                            <Button disabled>
                              <i className='fa fa-spinner fa-pulse'></i>
                            </Button>
                          </InputGroupAddon>
                        )}
                      </InputGroup>
                    </div>
                    <div className='col-sm-12 col-md-4'>
                      <label>* Estado</label>
                      <input
                        type='text'
                        name='estado'
                        className='form-control'
                        value={contratante.estado}
                        id={`c${i}_estado`}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-md-5'>
                      <label>* Cidade</label>
                      <input
                        type='text'
                        name='cidade'
                        className='form-control'
                        value={contratante.cidade}
                        id={`c${i}_cidade`}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                  </div>
                  <div className='row form-group'>
                    <div className='col-sm-12 col-md-6'>
                      <label>* Endereço</label>
                      <input
                        type='text'
                        name='endereco'
                        id={`c${i}_endereco`}
                        className='form-control'
                        value={contratante.endereco}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                    <div className='col-sm-9 col-md-4'>
                      <label>* Bairro</label>
                      <input
                        type='text'
                        name='bairro'
                        id={`c${i}_bairro`}
                        className='form-control'
                        value={contratante.bairro}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                    <div className='col-sm-3 col-md-2'>
                      <label>* Número</label>
                      <input
                        type='number'
                        name='numero'
                        id={`c${i}_numero`}
                        className='form-control'
                        min='0'
                        value={contratante.numero}
                        onChange={this.handleChangeContratantes.bind(this, i)}
                        required
                      />
                    </div>
                  </div>
                </div>
              ))}
              <br />
              <h5>Turma:</h5>
              <div className='row form-group'>
                <div className='col-sm-12 col-md-4'>
                  <label>* Cidade do contrato</label>
                  <input
                    className='form-control'
                    id='t_cidade'
                    value={this.state.cidade}
                    onChange={(e) => {
                      this.setState({
                        cidade: e.target.value,
                        botaoDownload: true,
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-4'>
                  <label>* Curso</label>
                  <input
                    className='form-control'
                    id='t_curso'
                    value={this.state.turma.curso}
                    onChange={(e) => {
                      this.setState({
                        turma: { ...this.state.turma, curso: e.target.value },
                        botaoDownload: true,
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-4'>
                  <label>* Universidade</label>
                  <input
                    className='form-control'
                    id='t_faculdade'
                    value={this.state.turma.faculdade}
                    onChange={(e) => {
                      this.setState({
                        turma: {
                          ...this.state.turma,
                          faculdade: e.target.value,
                        },
                        botaoDownload: true,
                      });
                    }}
                    required
                  />
                </div>
              </div>
              <div className='row form-group'>
                <div className='col-sm-12 col-md-4'>
                  <label>* Estado</label>
                  <input
                    className='form-control'
                    id='t_estado'
                    value={this.state.turma.estado}
                    onChange={(e) => {
                      this.setState({
                        turma: { ...this.state.turma, estado: e.target.value },
                        botaoDownload: true,
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-4'>
                  <label>* Data da Colação</label>
                  <input
                    type='date'
                    className='form-control'
                    id='t_fullDate'
                    value={this.state.turma.fullDate}
                    onChange={(e) => {
                      this.setState(
                        {
                          turma: {
                            ...this.state.turma,
                            fullDate: e.target.value,
                          },
                          botaoDownload: true,
                        },
                        () => {
                          this.handleChangeFullDate();
                        }
                      );
                    }}
                    required
                  />
                </div>
              </div>
            </div>
            <div
              name='Pagamento'
              hidden={!(this.state.tabsControle === 'pagamento')}
              style={styleTabBody}
            >
              <div className='row form-group'>
                <div className='col-sm-12 col-md-10'>
                  <div>
                    <div className='row form-group'>
                      <div className='col-sm-12'>
                        <h5>Informações do Contrato</h5>
                        <label>Valor total</label>:{' '}
                        <strong>R${this.state.valores.total}</strong>
                        <br />
                        <label>Data da colação</label>:{' '}
                        <strong>
                          {this.state.turma.fullDate
                            .split('-')
                            .reverse()
                            .join('/')}
                        </strong>
                        <br />
                        {!this.state.orcamento.pagamentoIndividual ? (
                          <small style={{ fontWeight: 600, color: '#DC3545' }}>
                            Atenção:
                            <ol>
                              <li>
                                O sistema só aceitará parcelas agendadas com até
                                45 dias antes da data de colação!
                              </li>
                              <li>
                                Não é possível agendar uma parcela com data
                                retroativa!
                              </li>
                              <li>
                                É possível agendar até 12 parcelas, desde que as
                                regras acima sejam cumpridas.
                              </li>
                            </ol>
                          </small>
                        ) : null}
                      </div>
                    </div>
                    {!this.state.orcamento.pagamentoIndividual ? (
                      <React.Fragment>
                        <div
                          className='row'
                          style={{
                            margin: '0 15px',
                            width: 'calc(100% - 30px)',
                          }}
                        >
                          <div
                            className='col-sm-12'
                            style={{
                              padding: 0,
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <label style={{ backgroundColor: 'white' }}>
                              Número de Parcelas
                            </label>
                            <div
                              style={{
                                backgroundColor: 'white',
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <button
                                className='btn btn-info btn-sm'
                                onClick={this.removeParcela.bind(this)}
                              >
                                <i className='fas fa-minus'></i>
                              </button>
                              <span style={{ width: 30, textAlign: 'center' }}>
                                {this.state.valores.parcelas.length}
                              </span>
                              <button
                                className='btn btn-info btn-sm'
                                onClick={this.addParcela.bind(this)}
                              >
                                <i className='fas fa-plus'></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            border: '1px solid #e9ecef',
                            padding: 15,
                            borderRadius: '.25rem',
                            marginTop: '-20px',
                          }}
                        >
                          {this.state.valores.parcelas.map((parcela, i) => (
                            <div key={i} className='row form-group'>
                              <div className='col-sm-6'>
                                <small>
                                  <label>Parcela {i + 1}</label>
                                </small>
                                <input
                                  type='date'
                                  className='form-control'
                                  onChange={this.changeData.bind(this, i)}
                                  value={parcela.data}
                                  onBlur={this.validarData.bind(this)}
                                />
                              </div>
                              <div className='col-sm-6'>
                                <small>
                                  <label style={{ color: 'white' }}>.</label>
                                </small>
                                <input
                                  type='number'
                                  className='numero-parcela form-control'
                                  value={parcela.valor}
                                  onChange={this.changeValorParcela.bind(
                                    this,
                                    i
                                  )}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </React.Fragment>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div
              name='Representante'
              hidden={!(this.state.tabsControle === 'representante')}
              style={styleTabBody}
            >
              <div className='row form-group'>
                <div className='col-sm-12 col-md-4'>
                  <label>* Representante</label>
                  <input
                    disabled
                    className='form-control'
                    id='cont_representante'
                    value={this.state.contratada.representante}
                    onChange={(e) => {
                      this.setState({
                        contratada: {
                          ...this.state.contratada,
                          representante: e.target.value,
                        },
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-4'>
                  <label>* CPF</label>
                  <InputMask
                    className='form-control'
                    id='cont_cpf'
                    mask='999.999.999-99'
                    value={this.state.contratada.cpf}
                    onChange={(e) => {
                      this.setState({
                        contratada: {
                          ...this.state.contratada,
                          cpf: e.target.value,
                        },
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-4'>
                  <label>* E-mail</label>
                  <input
                    className='form-control'
                    id='cont_email'
                    value={this.state.contratada.email}
                    onChange={(e) => {
                      this.setState({
                        contratada: {
                          ...this.state.contratada,
                          email: e.target.value,
                        },
                      });
                    }}
                    required
                  />
                </div>
              </div>
              <div className='row form-group'>
                <div className='col-sm-12 col-md-3'>
                  <label>* Rua</label>
                  <input
                    className='form-control'
                    id='cont_rua'
                    value={this.state.contratada.rua}
                    onChange={(e) => {
                      this.setState({
                        contratada: {
                          ...this.state.contratada,
                          rua: e.target.value,
                        },
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-3'>
                  <label>* Cidade</label>
                  <input
                    className='form-control'
                    id='cont_cidade'
                    value={this.state.contratada.cidade}
                    onChange={(e) => {
                      this.setState({
                        contratada: {
                          ...this.state.contratada,
                          cidade: e.target.value,
                        },
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-3'>
                  <label>* Estado</label>
                  <input
                    className='form-control'
                    id='cont_estado'
                    value={this.state.contratada.estado}
                    onChange={(e) => {
                      this.setState({
                        contratada: {
                          ...this.state.contratada,
                          estado: e.target.value,
                        },
                      });
                    }}
                    required
                  />
                </div>
                <div className='col-sm-12 col-md-3'>
                  <label>* Celular</label>
                  <InputMask
                    id='cont_telefone'
                    className='form-control'
                    mask='(99) 99999 9999'
                    value={this.state.contratada.telefone}
                    onChange={(e) => {
                      this.setState({
                        contratada: {
                          ...this.state.contratada,
                          telefone: e.target.value,
                        },
                      });
                    }}
                    required
                  />
                </div>
              </div>
            </div>
            <div
              name='Testemunhas'
              hidden={!(this.state.tabsControle === 'testemunhas')}
              style={styleTabBody}
            >
              {this.state.testemunhas.map((testemunha, i) => (
                <div key={i}>
                  <br />
                  <h5>Testemunha {i + 1}</h5>
                  <div className='row form-group'>
                    <div className='col-sm-12 col-md-4'>
                      <label>* Nome</label>
                      <input
                        name='nome'
                        className='form-control'
                        id={`test${i}_nome`}
                        value={testemunha.nome}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-md-4'>
                      <label>* Celular:</label>
                      <InputMask
                        name='tel'
                        id={`test${i}_tel`}
                        className='form-control'
                        mask='(99) 99999 9999'
                        value={testemunha.tel}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-md-4'>
                      <label>* E-mail:</label>
                      <input
                        type='email'
                        id={`test${i}_email`}
                        name='email'
                        className='form-control'
                        value={testemunha.email}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        required
                      />
                    </div>
                  </div>
                  <div className='row form-group'>
                    <div className='col-sm-12 col-md-3'>
                      <label>* CEP</label>
                      <InputGroup>
                        <InputMask
                          name='CEP'
                          id={`test${i}_CEP`}
                          className='form-control'
                          mask='99999-999'
                          value={testemunha.CEP}
                          onChange={this.handleChangeTestemunhas.bind(this, i)}
                          required
                        />
                        {!this.state.procurandoCepTestemunha[i] ? (
                          <InputGroupAddon addonType='append'>
                            <Button
                              onClick={this.encontrarCidadeTestemunha.bind(this, i)}
                            >
                              Ok
                            </Button>
                          </InputGroupAddon>
                        ) : (
                          <InputGroupAddon addonType='append'>
                            <Button disabled>
                              <i className='fa fa-spinner fa-pulse'></i>
                            </Button>
                          </InputGroupAddon>
                        )}
                      </InputGroup>
                    </div>
                    <div className='col-sm-12 col-md-3'>
                      <label>* Estado</label>
                      <input
                        name='estado'
                        className='form-control'
                        id={`test${i}_estado`}
                        value={testemunha.estado}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-md-3'>
                      <label>* Cidade</label>
                      <input
                        name='cidade'
                        className='form-control'
                        id={`test${i}_cidade`}
                        value={testemunha.cidade}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-md-3'>
                      <label>* Bairro</label>
                      <input
                        name='bairro'
                        className='form-control'
                        id={`test${i}_bairro`}
                        value={testemunha.bairro}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                  </div>
                  <div className='row form-group'>
                    <div className='col-sm-12 col-md-6'>
                      <label>* Endereço</label>
                      <input
                        name='endereco'
                        className='form-control'
                        id={`test${i}_endereco`}
                        value={testemunha.endereco}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        disabled
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-md-3'>
                      <label>RG:</label>
                      <input
                        type='text'
                        name='rg'
                        className='form-control'
                        id={`test${i}_rg`}
                        maxLength={15}
                        value={testemunha.rg}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                      />
                    </div>
                    <div className='col-sm-12 col-md-3'>
                      <label>* CPF:</label>
                      <InputMask
                        name='cpf'
                        className='form-control'
                        id={`test${i}_cpf`}
                        mask='999.999.999-99'
                        value={testemunha.cpf}
                        onChange={this.handleChangeTestemunhas.bind(this, i)}
                        required
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <br />
            <br />
            <div>
              <button
                className='btn btn-success'
                onClick={this.salvarContrato.bind(this)}
                disabled={
                  this.state.finalizarOrcamento || this.state.salvarOrcamento
                }
              >
                {this.state.salvarOrcamento ? (
                  <span>
                    <i className='fa fa-spinner fa-pulse'></i> Salvando{' '}
                  </span>
                ) : (
                  <span>
                    <i className='fas fa-save'></i> Salvar{' '}
                  </span>
                )}
              </button>{' '}
              <button
                className='btn btn-success'
                onClick={this.downloadProposta.bind(this)}
                disabled={
                  this.state.botaoDownload ||
                  this.state.finalizarOrcamento ||
                  this.state.salvarOrcamento
                }
              >
                <i
                  className={
                    this.state.gerarDownload
                      ? 'fa fa-spinner fa-pulse'
                      : 'fas fa-download'
                  }
                ></i>{' '}
                Download
              </button>{' '}
              <button
                className='btn btn-danger'
                style={{ float: 'right' }}
                onClick={this.finalizarOrcamento.bind(this)}
                disabled={
                  this.state.botaoDownload ||
                  this.state.finalizarOrcamento ||
                  this.state.salvarOrcamento
                }
              >
                <i
                  className={
                    this.state.finalizarOrcamento
                      ? 'fa fa-spinner fa-pulse'
                      : 'fas fa-exclamation-circle'
                  }
                ></i>{' '}
                Liberar para assinaturas
              </button>
            </div>
          </React.Fragment>
        ) : (
          <h4>Não existem contatos cadastrados para este cliente.</h4>
        )}
      </div>
    );
  }
}

const styleTabBody = {
  padding: '5px',
  borderLeft: '1px solid #dee2e6',
  borderRight: '1px solid #dee2e6',
  borderBottom: '1px solid #dee2e6',
};
